function getChildren(children?: string | string[]) {
  if (!children) return undefined;
  if (Array.isArray(children))
    if (children.length === 0) return undefined;
    else if (children.length === 1) return getChildren(children[0]);

  return children;
}

export function ErrorMessage({
  children,
}: {
  children?: string | string[];
}): JSX.Element {
  const childrenToRender = getChildren(children);

  if (!childrenToRender) return undefined as React.ReactNode as JSX.Element;

  if (Array.isArray(childrenToRender)) {
    return (
      <ul>
        {childrenToRender.map((child) => (
          <li className="hc-error-text" key={child} role="alert">
            {child}
          </li>
        ))}
      </ul>
    );
  }

  return (
    <span className="hc-error-text" role="alert">
      {children}
    </span>
  );
}
